export enum RefundType {
    none = 0,
    manual = 1,
    automatic = 2
}